import "./chatting.scss";
import { useEffect } from "react";
import PageTitle from "../../HOC/page-title";
import CardWrapper from "../../HOC/card/card";
import CardHeader from "../../components/card-header";
import { Menu, Dropdown, Button } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import ChatMessage from "../../components/chat-message";
import SendMessage from "../../components/send-message";
import imgnagib from "../../assets/profile.png";

const title =
  "مناقشة مشروع إبرار التوعية الافراد التابع لجمعية الصفا الخيرية";

const menu = (
  <Menu style={{ textAlign: "center" }}>
    <Menu.Item>عرض الصور</Menu.Item>
    <Menu.Item>عرض الملفات</Menu.Item>
    <Menu.Item>عرض الروابط</Menu.Item>
    <Menu.Item>عرض الرسائل الهامة</Menu.Item>
  </Menu>
);
const Chatting = ({ handleChangeKey }) => {
  useEffect(() => {
    handleChangeKey(3);
  }, []);
  return (
    <div className="chatting-container">
      <CardWrapper>
        <CardHeader title={title}>
          <Dropdown overlay={menu} placement="bottomLeft" arrow>
            <MoreOutlined className="dropdown-list-icon" />
          </Dropdown>
        </CardHeader>
        <div className="page-content">
        <ChatMessage author={" نجيب محمد الشاوي"} date={"منذ يوم واحد "} imgAvatar={imgnagib} msg={"يرجى مراجعة الطلب في تقييمات حول دراسة هذا المشروع يمكنك قراءة هذا نص تعريفي للقراءة فقط يستخدم هذا النص للقراءة والتحويل من نص مرئي إلى مكتوب نشكرك على قرائتكم هذا النص شكرا جدا لكم وعلى قبوكلم الطلب "}/>
        <ChatMessage author={"عبدالله محمد صالح"} date={"منذ عشر دقائق "} imgAvatar={imgnagib} msg={"تمت مراجعة الطلب الان شكرا لكم نعمل على دراسة هذا المشروع يمكنك قراءة هذا نص تعريفي للقراءة فقط يستخدم هذا النص للقراءة والتحويل من نص مرئي إلى مكتوب نشكرك على قرائتكم هذا النص شكرا جدا لكم وعلى قبوكلم الطلب "}/>
        <ChatMessage author={"محمد نجيب الشاوي"} date={"الآن "} imgAvatar={imgnagib} msg={" مراجعة الطلب في تقييمات حول دراسة هذا المشروع يمكنك قراءة هذا نص تعريفي للقراءة فقط يستخدم هذا النص للقراءة والتحويل من نص مرئي إلى مكتوب نشكرك على قرائتكم هذا النص شكرا جدا لكم وعلى قبوكلم الطلب "}/>
          <SendMessage />
        </div>
      </CardWrapper>
    </div>
  );
};

export default PageTitle(Chatting);
